import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { useShowCredits } from "@outschool/ui-components-website";

export default function useEnrollButtonCTA({
  isOngoing,
  isClub,
  isSelfPaced,
  isInProgress,
  isWaitlistable = false,
  sectionProgress,
  showWaitlistedButton = false,
  showNotAcceptingWaitlist = false,
  canEnroll
}: {
  isOngoing: boolean;
  isClub: boolean;
  isSelfPaced: boolean;
  isInProgress: boolean;
  isWaitlistable?: boolean;
  sectionProgress?: {
    currentWeek: number;
  };
  showWaitlistedButton?: boolean;
  showNotAcceptingWaitlist?: boolean;
  canEnroll: boolean;
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\hooks\\useEnrollButtonCTA"
  );
  const { isLoggedIn, currentUser } = useSession();
  const showCredits = useShowCredits();

  if (showCredits && !currentUser?.hasSubscription && !isLoggedIn) {
    return t`Join`;
  }

  if (
    showCredits &&
    currentUser?.hasSubscription &&
    !currentUser?.canPayWithSubscriptionCredits
  ) {
    return t`Resume`;
  }

  if (isInProgress && !!sectionProgress?.currentWeek) {
    return t("Join Week {{currentWeek}}", {
      currentWeek: sectionProgress?.currentWeek
    });
  }

  return isSelfPaced && canEnroll
    ? t`Enroll Now, Start Anytime`
    : isSelfPaced && !canEnroll
    ? t`Not Accepting Enrollments`
    : showNotAcceptingWaitlist
    ? t`Not Accepting Waitlist`
    : showWaitlistedButton
    ? t`Waitlisted`
    : isWaitlistable
    ? t`Join Waitlist`
    : isOngoing
    ? t`Subscribe`
    : isClub
    ? t`Join Group`
    : isInProgress
    ? t`Enroll Late`
    : t`Enroll`;
}
